// Ricalcola "X di Y" dal DOM: unica fonte di verità dopo hydrate/load-more/load-previous
window.updatePLPProductsCount = function updatePLPProductsCount() {
  const counter = document.querySelector('.js-products-count');
  const grid = document.querySelector('#product-grid');
  if (!counter || !grid || !counter.dataset.template) return;

  // solo le card prodotto: i banner non hanno .grid__item
  const loaded = grid.querySelectorAll(':scope > li.grid__item').length;

  counter.dataset.loaded = loaded;
  counter.textContent = counter.dataset.template.replace('__COUNT__', loaded);
};

async function hydrateCollectionFromPageParam({
  gridSelector = '#product-grid',
  maxPagesToHydrate = 5,
} = {}) {
  const grid = document.querySelector(gridSelector);
  if (!grid) return;

  const sectionId = grid.dataset.id;
  if (!sectionId) return;

  const url = new URL(window.location.href);
  const page = parseInt(url.searchParams.get('page') || '1', 10);
  if (!page || page <= 1) return;

  const targetPage = Math.min(page, maxPagesToHydrate);

  if (grid.dataset.hydrated === 'true') return;
  grid.dataset.hydrated = 'true';

  const currentItems = Array.from(grid.querySelectorAll(':scope > li'));

  const fetchPageItems = async (p) => {
    const u = new URL(window.location.href);
    u.searchParams.set('page', String(p));
    u.searchParams.set('section_id', sectionId);

    const html = await (await fetch(u.toString(), { credentials: 'same-origin' })).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('#product-grid > li'));
  };

  grid.innerHTML = '';

  for (let p = 1; p < targetPage; p++) {
    const items = await fetchPageItems(p);
    items.forEach(li => grid.appendChild(li));
  }

  currentItems.forEach(li => grid.appendChild(li));

  window.updatePLPProductsCount();

  document.dispatchEvent(new CustomEvent("swiper:reinitialize"));
  document.dispatchEvent(new CustomEvent("swatchplp:reinitialize"));
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  document.dispatchEvent(new CustomEvent("listing:newProducts", { detail: { index: 0 } }));
}

document.addEventListener('DOMContentLoaded', () => {
  hydrateCollectionFromPageParam({
    maxPagesToHydrate: 6
  });
});



function savePLPScroll() {
  const scrollData = {
    scrollY: window.scrollY,
    url: window.location.href
  };

  sessionStorage.setItem('plp-scroll', JSON.stringify(scrollData));
}

// salva quando clicchi un prodotto
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="/products/"]');
  if (!link) return;

  savePLPScroll();
});

function restorePLPScroll() {
  const data = sessionStorage.getItem('plp-scroll');
  if (!data) return;

  const scrollData = JSON.parse(data);

  if (scrollData.url !== window.location.href) return;

  requestAnimationFrame(() => {
    window.scrollTo({
      top: scrollData.scrollY,
      behavior: "instant"
    });
  });
}